import React from 'react'
import './home.css' 
import RenderBooks from '../../components/renderBooks/renderBooks';
const Home = () => {




  return (
    <div className=''>
      
       
        <RenderBooks />
        
    </div>


  )
}

export {Home}